/**
 * 页面入口，页面单独作为一个组件
 */
import React, { Component } from 'react';
import {
    // BrowserRouter as Router,
    Router,
    Route,
    Switch
} from 'react-router-dom';
import Routes from './routes';
import Provider from 'services/provider';
import Store from 'services/store';
import './index.less';
import { trackUrl, analytics } from 'library/track-url';
import createBrowserHistory from 'history/createBrowserHistory';

const history = createBrowserHistory();

//页面统计埋点
let siteData = window.__SITEDATA__ || {};
trackUrl(siteData.code, window.location.pathname);
analytics(siteData.projectId || siteData.code);

history.listen((e) => {
    trackUrl(siteData.code, e.pathname);
    analytics(siteData.projectId || siteData.code);
});

//获取初始的状态，服务器渲染的状态存在__INITIAL_STATE__全局变量中
const initialState = window.__INITIAL_STATE__;

//根据初始状态创建Store
Store.setState(initialState);

/**
 * 页面入口
 */
class Index extends Component {
    render() {
        return (
            <Provider store={Store}>
                <Router history={history}>
                    <div>
                        <Switch>
                            {
                                Routes.map((route, n) => (
                                    <Route key={n} {...route} />
                                ))
                            }
                        </Switch>
                    </div>
                </Router>
            </Provider>
        );
    }
}

export default Index;






// WEBPACK FOOTER //
// ./_source/cqsx/pages/cqsx/index.js